import { ArrowDownToLine } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { Button } from '~/components/component-library'
import { IAddress } from '~/types'

type DepositButtonProps = {
  defaultAccount?: IAddress
  isDisabled?: boolean
  disabledReason?: string
} & (
  | { asChild: true; children: React.ReactNode }
  | { asChild?: false; children?: never }
)

const buildDepositPath = (defaultAccount?: IAddress) => {
  const params = new URLSearchParams()
  if (defaultAccount) {
    params.set('account', defaultAccount)
  }
  const queryString = params.toString()
  return `/deposit${queryString ? `?${queryString}` : ''}`
}

export const DepositButton = (props: DepositButtonProps) => (
  <SplitsLink path={buildDepositPath(props.defaultAccount)}>
    {props.asChild ? (
      props.children
    ) : (
      <Button
        variant="secondary"
        prefix={<ArrowDownToLine />}
        isDisabled={props.isDisabled}
        disabledReason={props.disabledReason}
      >
        Deposit
      </Button>
    )}
  </SplitsLink>
)
